
export const MyModalContainer = () => <div id={'my-modal-container'}/>